import { BaseModel } from 'src/app/shared/models/base.model';

export class Subcategory extends BaseModel{
    static fromJsonToObject(jsonData:any):Subcategory{
        return Object.assign(new Subcategory(),jsonData);
    }
}